
import React from 'react';
import { FileUploadSection } from './category-upload/FileUploadSection';
import { FilePreview } from './category-upload/FilePreview';
import { CategoryPreview } from './category-upload/CategoryPreview';
import { ProcessingIndicator } from './category-upload/ProcessingIndicator';
import { EmptyState } from './category-upload/EmptyState';
import { useCategoryUpload } from './category-upload/useCategoryUpload';
import { Alert, AlertDescription } from '@/components/ui/alert';
import { Info } from 'lucide-react';

interface CategoryUploadProps {
  onUploadComplete: () => void;
}

const CategoryUpload = ({ onUploadComplete }: CategoryUploadProps) => {
  const {
    file,
    previewData,
    isProcessing,
    fileInputRef,
    bulkCreateCategories,
    handleFileChange,
    handleUpload,
    handleReset
  } = useCategoryUpload(onUploadComplete);

  const showEmptyState = !file && !isProcessing && previewData.length === 0;

  return (
    <div className="space-y-6">
      <Alert className="bg-blue-50 border-blue-200">
        <Info className="h-4 w-4 text-blue-500" />
        <AlertDescription>
          Upload an Excel file with a column named "name" containing your category names.
        </AlertDescription>
      </Alert>

      <FileUploadSection 
        isProcessing={isProcessing}
        onFileChange={handleFileChange}
      />

      {file && <FilePreview file={file} />}
      
      <ProcessingIndicator isProcessing={isProcessing} />
      
      <CategoryPreview 
        categories={previewData}
        isPending={bulkCreateCategories.isPending}
        onUpload={handleUpload}
        onReset={handleReset}
      />

      {showEmptyState && (
        <EmptyState onSelectFile={() => fileInputRef.current?.click()} />
      )}
    </div>
  );
};

export default CategoryUpload;
